/* src/app/shared/components/empty-state/empty-state.component.scss */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: var(--cds-text-light);
}
.empty-state-image {
  width: 280px;
  height: 206px;
  margin-bottom: 24px;
  object-fit: contain;
}
.empty-state-message {
  font-size: 16px;
  font-weight: 600;
  color: var(--cds-text-strong);
  margin: 0;
  line-height: 1.5;
}
/*# sourceMappingURL=empty-state.component.css.map */
